import { render, staticRenderFns } from "./segmentModal.vue?vue&type=template&id=96639e32&scoped=true"
import script from "./segmentModal.vue?vue&type=script&lang=js"
export * from "./segmentModal.vue?vue&type=script&lang=js"
import style0 from "./segmentModal.vue?vue&type=style&index=0&id=96639e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96639e32",
  null
  
)

export default component.exports